export default __webpack_public_path__ + "static/media/apple.9a2ae56f.png";